const fileOpenNewTab = (urlLink) => {
  window.open(urlLink, '_blank');
};

export default fileOpenNewTab;
